import { Component } from 'react'
import MaskedInput from 'react-maskedinput'

import { ErrorMessage } from '../NarusMaterial/ErrorMessage'
import { RequiredSpan } from '../NarusMaterial/RequiredSpan'

import {
  makeAutobindedInput,
  makeValidatedInput
} from './FormBuilder'

export class MaskedTextField extends Component {
  constructor (props, context) {
    super(props, context)
    this.state = {
      value: props.value ? String(props.value) : undefined,
      conditionalMask: '',
      setConditionalMask: false,
      clearMask: false
    }
  }

  UNSAFE_componentWillMount () {
    const { value } = this.state
    const { conditional } = this.props
    if (conditional === 'Temp' && value && value[0] === '1') {
      this.tempMask()
    }
  }

  UNSAFE_componentWillReceiveProps (props) {
    this.setState({
      value: props.value ? String(props.value) : undefined
    })
  }

  componentDidUpdate () {
    const { value, setConditionalMask, conditionalMask, clearMask } =
      this.state
    const { conditional } = this.props

    if (
      conditional &&
      conditional === 'Temp' &&
      !setConditionalMask &&
      value &&
      value[0] === '1'
    ) {
      this.tempMask()
    }

    if (conditional && conditionalMask && !value) {
      this.clearConditional()
    }

    if (clearMask) {
      this.clearConditionalMask()
    }
  }

  clearConditional () {
    this.setState({
      clearMask: true
    })
  }

  clearConditionalMask () {
    const { clearMask } = this.state
    if (clearMask) {
      this.setState({
        conditionalMask: undefined,
        clearMask: false,
        setConditionalMask: false
      })
    }
  }

  tempMask () {
    this.setState({
      conditionalMask: '111.1',
      setConditionalMask: true
    })
  }

  renderRequired () {
    const { required } = this.props
    if (!required) {
      return <div />
    }
    return <RequiredSpan />
  }

  render () {
    const {
      label,
      mask,
      onChange,
      required,
      onBlur,
      disabled,
      helperText,
      errors
    } = this.props

    const { value, conditionalMask } = this.state

    const handleOnChange = event => {
      if (onChange) {
        onChange(event.target.value)
      }
    }

    const labelClass = value ? 'valid' : ''
    const className = [ 'nh-textbox' ]

    if (errors && errors.length) {
      className.push('error')
    }
    return (
      <div className='text-container masked-input'>
        <MaskedInput
          className={className.join(' ')}
          mask={conditionalMask || mask}
          onChange={handleOnChange}
          onKeyDown={this.keyDown}
          placeholder=''
          value={value}
          required={required}
          onBlur={onBlur}
          disabled={disabled}
        />
        <span className='bar' />
        <label id={labelClass}>{label}</label>
        {this.renderRequired()}
        <ErrorMessage errors={errors} />
        {helperText && (
          <div className='helper-text'>
            {helperText}
            {' '}
          </div>
        )}
      </div>
    )
  }
}

export const MaskedTextInput = makeAutobindedInput(
  makeValidatedInput(MaskedTextField)
)
